/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Container, Spinner, Modal } from "react-bootstrap";
import AwareButton from "../../components/button";
import Navbar from "../../components/navbar";
import Layout from "../../layout";
import { useBetween } from "use-between";
import useApi from "../useApi";

import "./index.scss";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const PromotionType = Object.freeze({
    DISCOUNT: "DISCOUNT",
    BOGO: "BOGO",
    COUPON: "COUPON",
    BANNER: "BANNER",
    SPOTLIGHT: "SPOTLIGHT",
});

const PromotionTypeLabels = Object.freeze({
    [PromotionType.DISCOUNT]: "Discount",
    [PromotionType.BOGO]: "Buy One Get One (BOGO)",
    [PromotionType.COUPON]: "Coupon Code",
    [PromotionType.BANNER]: "Banner",
    [PromotionType.SPOTLIGHT]: "Spotlight",
});

const ContentManagement = () => {
    // const [homeBanners, setHomeBanners] = useState({
    //     banners: [
    //         {
    //             imagePath: "",
    //             imageLink: ""
    //         },
    //         {
    //             imagePath: "",
    //             imageLink: ""
    //         },
    //         {
    //             imagePath: "",
    //             imageLink: ""
    //         }
    //     ]
    // });

    const [contents, setContents] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [contentToDelete, setContentToDelete] = useState(null);
    const {
        updating,
        isAdmin,
        getContents,
        setUpdating,
        logout,
        deleteContent
    } = useBetween(useApi);
    const navigate = useNavigate();
    const location = useLocation();

    const fetchContents = () => {
        setUpdating(true);
        getContents()
            .then((response) => {
                if (
                    response.type === "success" &&
                    response.contents &&
                    response.contents.length > 0
                ) {
                    setContents(response.contents);
                }
                setUpdating(false);
            })
            .catch((error) => {
                setUpdating(false);
                logout();
            });
    };

    useEffect(() => {
        if (isAdmin !== true) {
            navigate("/profile/details");
        } else {
            fetchContents();
        }
    }, [location.pathname, isAdmin]);

    const handleEdit = (contentId) => {
        navigate(`/profile/contents/${contentId}/update`);
    };

    const handleDelete = (contentId, contentTitle) => {
        setContentToDelete({ id: contentId, title: contentTitle });
        setShowDeleteModal(true);
    };

    const confirmDelete = () => {
        if (contentToDelete) {
            deleteContent(contentToDelete.id)
                .then(() => {
                    toast.success("Content deleted successfully");
                    fetchContents();
                })
                .catch((err) => {
                    toast.error("Failed to delete content");
                    console.error(err);
                });

            setShowDeleteModal(false);
            setContentToDelete(null);
        }
    };

    const cancelDelete = () => {
        setShowDeleteModal(false);
        setContentToDelete(null);
    };

    const handleCreate = () => {
        // TODO: Navigate to create page
        navigate('/profile/contents/create', { state: { contentIndex: null } });
    };

    return (
        <Layout>
            {isAdmin === true ? (
                <div className='bg-gray'>
                    <Container className='content-container d-flex'>
                        <Navbar active='content' />
                        <div className='content-wrapper'>
                            <div className='content-section'>
                                <div className='content-header'>
                                    <h3>Content Management</h3>
                                </div>
                                <div className='content-content'>
                                    <div className='content-header justify-content-end'>
                                        <AwareButton
                                            className='btn btn-primary create-btn'
                                            onClick={handleCreate}
                                        >
                                            Create
                                        </AwareButton>
                                    </div>

                                    <div className='table-wrapper'>
                                        <table className='content-table'>
                                            <thead>
                                                <tr>
                                                    <th>Image</th>
                                                    <th>Name</th>
                                                    <th>Type</th>
                                                    <th className='text-end'>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {contents && Object.keys(contents).length > 0 ? (
                                                    contents.map((content, index) => (
                                                        <tr key={`content-${index}`}>
                                                            <td>
                                                                <div className='content-image'>
                                                                    {content.imagePath ? (
                                                                        <img
                                                                            src={content.imagePath}
                                                                            alt={content.title || 'Content'}
                                                                            style={{
                                                                                width: '80px',
                                                                                height: '80px',
                                                                                objectFit: 'cover',
                                                                                borderRadius: '8px',
                                                                                border: '1px solid #e8e8e8'
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <div
                                                                            style={{
                                                                                width: '80px',
                                                                                height: '80px',
                                                                                backgroundColor: '#f5f5f5',
                                                                                borderRadius: '8px',
                                                                                border: '1px solid #e8e8e8',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                color: '#999',
                                                                                fontSize: '12px'
                                                                            }}
                                                                        >
                                                                            No Image
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='content-title'>
                                                                    {content.title || 'No title set'}
                                                                </div>
                                                                <div className='content-subtitle'>
                                                                    {content.description
                                                                        ? content.description.length > 50
                                                                            ? content.description.substring(0, 50) + '...'
                                                                            : content.description
                                                                        : 'No description'}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='content-type'>
                                                                    {content.promotionType ? (
                                                                        <span style={{
                                                                            padding: '6px 12px',
                                                                            backgroundColor: '#f0f0f0',
                                                                            borderRadius: '20px',
                                                                            fontSize: '13px',
                                                                            fontWeight: '600',
                                                                            color: '#1a1a1a',
                                                                            display: 'inline-block'
                                                                        }}>
                                                                            {PromotionTypeLabels[content.promotionType]}
                                                                        </span>
                                                                    ) : (
                                                                        <span style={{ color: '#999', fontSize: '13px' }}>No type</span>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td className='text-end'>
                                                                <div className='action-buttons'>
                                                                    <AwareButton
                                                                        className='btn btn-outline-primary btn-sm me-2'
                                                                        onClick={() => handleEdit(content._id)}
                                                                    >
                                                                        View
                                                                    </AwareButton>
                                                                    <AwareButton
                                                                        className='btn btn-outline-danger btn-sm'
                                                                        onClick={() => handleDelete(content._id, content.title || 'Untitled Content')}
                                                                    >
                                                                        Delete
                                                                    </AwareButton>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan='4' className='text-center py-4'>
                                                            No contents available. Click "Create" to add a new content.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            ) : null}
            {updating ? (
                <div className='page-loading'>
                    <Spinner animation='border' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                    </Spinner>
                </div>
            ) : null}

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={cancelDelete} centered>
                <Modal.Header closeButton style={{ borderBottom: '2px solid #f0f0f0' }}>
                    <Modal.Title style={{ fontSize: '20px', fontWeight: '700', color: '#1a1a1a' }}>
                        Confirm Delete
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: '24px' }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        marginBottom: '16px'
                    }}>
                        <div style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '50%',
                            backgroundColor: '#fee',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0
                        }}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#dc3545"
                                strokeWidth="2"
                            >
                                <path d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div>
                            <p style={{
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#1a1a1a',
                                margin: 0,
                                marginBottom: '8px'
                            }}>
                                Are you sure you want to delete this content?
                            </p>
                            {contentToDelete && (
                                <p style={{
                                    fontSize: '14px',
                                    color: '#666',
                                    margin: 0
                                }}>
                                    <strong>"{contentToDelete.title}"</strong>
                                </p>
                            )}
                        </div>
                    </div>
                    <p style={{
                        fontSize: '14px',
                        color: '#666',
                        margin: 0,
                        lineHeight: '1.6'
                    }}>
                        This action cannot be undone. The content will be permanently removed from the system.
                    </p>
                </Modal.Body>
                <Modal.Footer style={{
                    borderTop: '2px solid #f0f0f0',
                    padding: '16px 24px',
                    gap: '12px'
                }}>
                    <AwareButton
                        className='btn btn-secondary'
                        onClick={cancelDelete}
                        style={{
                            padding: '10px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            borderRadius: '8px',
                            border: '2px solid #e8e8e8',
                            backgroundColor: '#fff',
                            color: '#1a1a1a'
                        }}
                    >
                        Cancel
                    </AwareButton>
                    <AwareButton
                        className='btn btn-danger'
                        onClick={confirmDelete}
                        style={{
                            padding: '10px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            borderRadius: '8px',
                            backgroundColor: '#dc3545',
                            border: '2px solid #dc3545',
                            color: '#fff'
                        }}
                    >
                        Delete Content
                    </AwareButton>
                </Modal.Footer>
            </Modal>
        </Layout>
    );
};

export default ContentManagement;
